import React from 'react';
import cls from './DaysModeBody.module.css';
import classNames from 'classnames';
import { DaysModeStage } from './DaysModeStage/DaysModeStage';

export const DaysModeBody = ({ stages }) => {
    return (
        <div className={classNames(cls.DaysModeBody)}>
            {stages.map((stage) => (
                <DaysModeStage key={stage.id} stage={stage} />
            ))}
        </div>
    );
};
